import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, FileText, Building2, IdCard, Clock, CheckCircle, XCircle } from 'lucide-react';
import { useI18n } from '@/contexts/I18nContext';
import api from '@/lib/api';

export default function AdminDashboard() {
  const { t } = useI18n();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/stats/dashboard').then(r => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) return <div className="flex items-center justify-center h-64 text-muted-foreground">{t('common.loading')}</div>;

  const cards = [
    { label: t('admin.total_users'), value: stats.total_users, icon: Users, color: '#007FFF' },
    { label: t('admin.citizens'), value: stats.total_citizens, icon: Users, color: '#475569' },
    { label: t('admin.apps'), value: stats.total_applications, icon: FileText, color: '#007FFF' },
    { label: t('dash.pending'), value: stats.pending, icon: Clock, color: '#F7D618' },
    { label: t('status.approved'), value: stats.approved, icon: CheckCircle, color: '#009543' },
    { label: t('status.rejected'), value: stats.rejected, icon: XCircle, color: '#CE1021' },
    { label: t('admin.total_cards'), value: stats.total_cards, icon: IdCard, color: '#009543' },
    { label: t('admin.total_emb'), value: stats.total_embassies, icon: Building2, color: '#007FFF' },
  ];

  return (
    <div className="space-y-6 animate-fade-in" data-testid="admin-dashboard">
      <h1 className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>{t('admin.title')}</h1>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {cards.map((c, i) => {
          const Icon = c.icon;
          return (
            <Card key={i} className="border">
              <CardContent className="p-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${c.color}15` }}>
                    <Icon className="w-5 h-5" style={{ color: c.color }} />
                  </div>
                  <div>
                    <p className="text-xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>{c.value}</p>
                    <p className="text-xs text-muted-foreground">{c.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {stats.by_country?.length > 0 && (
        <Card className="border">
          <CardHeader><CardTitle className="text-lg" style={{ fontFamily: 'Outfit, sans-serif' }}>{t('admin.by_country')}</CardTitle></CardHeader>
          <CardContent>
            <div className="space-y-3">
              {stats.by_country.map((c, i) => (
                <div key={i} className="flex items-center justify-between">
                  <span className="text-sm">{c.country}</span>
                  <div className="flex items-center gap-2">
                    <div className="w-32 h-2 bg-muted rounded-full overflow-hidden">
                      <div className="h-full bg-[#007FFF] rounded-full"
                        style={{ width: `${(c.count / Math.max(...stats.by_country.map(x => x.count))) * 100}%` }} />
                    </div>
                    <span className="text-sm font-medium w-8 text-right">{c.count}</span>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
